import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

// 每日任务
export function daily(data) {
  // console.log('每日任务',data)
  return plaintextrequest({
    url: "/Task/daily",
    method: "post",
    data,
  });
}
// 签到
export function signTask(data) {
  return request({
    url: "/Task/qiandao",
    method: "post",
    data,
  });
}
// 任务领取
export function achieve(data) {
  return request({
    url: "/Task/gettask",
    method: "post",
    data,
  });
}
// 金币兑换余额
export function pointExchange(data) {
  // console.log('金币兑换余额',data)
  // debugger
  return request({
    url: "/GoldCoin/exchangeMoney",
    method: "post",
    data,
  });
}

// 试玩任务列表
export function Trial(data) {
  return plaintextrequest({
    url: "/Task/Trial",
    method: "post",
    data,
  });
}

// 领取试玩任务
export function getTrial(data) {
  console.log("领取试玩任务", data);
  return request({
    url: "/Task/getTrial",
    method: "post",
    data,
  });
}
// 领取任务奖励
export function achieveTrial(data) {
  // console.log('领取任务奖励----------------',data)
  return request({
    url: "/Task/achieveTrial",
    method: "post",
    data,
  });
}

// 积分获取记录
export function getLog(data) {
  return plaintextrequest({
    url: "/Task/goldgetlog",
    method: "post",
    data,
  });
}
